import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements AfterViewInit, OnDestroy {
  private fragmentSub?: Subscription;
  contactForm: FormGroup;
  submitted = false;
  loading = false;
  success = false;
  error = false;

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute
  ) {
    this.contactForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      company: [''],
      message: ['', Validators.required]
    });
  }

  ngAfterViewInit(): void {
    this.fragmentSub = this.route.fragment.subscribe((fragment) => {
      if (fragment === 'contact-form') {
        requestAnimationFrame(() => this.scrollToForm());
      }
    });
  }

  ngOnDestroy(): void {
    this.fragmentSub?.unsubscribe();
  }

  private scrollToForm(): void {
    document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  onSubmit() {
    this.submitted = true;
    this.loading = true;
    this.success = false;
    this.error = false;

    if (this.contactForm.invalid) {
      this.loading = false;
      return;
    }

    this.http.post(`${environment.apiUrl}/send-mail`, this.contactForm.value)
      .subscribe({
        next: (response: any) => {
          this.loading = false;
          if (response.success) {
            this.success = true;
            this.submitted = false;
            this.contactForm.reset();
          } else {
            this.error = true;
            console.error('Email sending failed:', response.message);
          }
        },
        error: (error) => {
          this.loading = false;
          this.error = true;
          console.error('Email sending failed:', error);
        }
      });
  }
} 